import type { FaireProductEntity } from "../../entity_types/product";

export const p_ktev6kj4c6: FaireProductEntity = {
  token: "p_ktev6kj4c6",
  type: "product",
  name: "Crispy Ho Chili Crunch (Premium Chili Crisp, No Seed Oils)",
  brandToken: "b_7sm36dmfku",
  brandName: "Crispy Ho",
  imageUrl:
    "https://cdn.faire.com/fastly/af8ec275c10b33417f006d886d796cdfe46b5cb53f1ab483cc06b6c525502987.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d04c8232890553a98f5613e0fb044507b4bcc86fc460c33ace1c1832f065619f.jpeg",
    "https://cdn.faire.com/fastly/a5eda223188f971b3f8b50bf14fc6e42ef83aa971303f19d2a9c66978bb2f409.jpeg",
    "https://cdn.faire.com/fastly/0e4ea0e3398a779a255ea7cf0b8fd3f70d2515676f41e3c3dc3e2bc246857272.jpeg",
    "https://cdn.faire.com/fastly/73e6f63a61cafc64f7d4f08eef688beca032ae2275e8a8fd7205e20a135151e6.png",
    "https://cdn.faire.com/fastly/f7ee629ac47df037af343eb55a63be3fa84f9109175ae91cf7c64b41ca5fa0d2.jpeg",
    "https://cdn.faire.com/fastly/ce8ed5fe97aac19613963e0ded9d90ac891a238c7f55acf4f9a59913aea69b39.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Crispy Ho is a spicy, crunchy, umami bomb packed with toasty bits of crispy garlic and shallots.  We are NOT your typical chili crunch.  \n\n🌶️ NO SEED OILS: Made with non-GMO avocado oil, not highly processed seed oils like other chili crisp brands. \n\n🌶️ CLEAN INGREDIENTS: Vegan, gluten free, all natural, no preservatives, no soy, no MSG, no nuts, no sesame, no shortcuts. Just clean, easy-to-understand ingredients for a much healthier (and tastier) chili crisp.\n\n🌶️ REAL CRUNCH: Crunch you can hear, built from perfectly fried bits of crispy garlic and shallots. Others advertise crunch, Crispy Ho delivers it.\n\n🌶️ BUZZWORTHY: #1 best selling condiment in the hot sauce, chili oil, chili crisp categories at Erewhon. This is not your average Ho.\n\n🌶️ EVERY MEAL, UPGRADED: Mushroom powder, toasty garlic, and shallots build a deep, savory sauce balanced across all four notes - spicy, savory, sweet, and salty. Drizzle over rice, noodles, and dumplings. Scoop onto eggs, fish, and meat. ",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:24.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
